import React, { useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { GridStack } from "gridstack";

import { useTranslation } from 'react-i18next';
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import PublicAnnouncements from "../PublicAnnoncements/PublicAnnoncements";
import DocumentRepo from "./DocumentRepo";

const DocumentRepoMain = (props) => {
  const { t, i18n } = useTranslation();
 
  useEffect(() => {
    GridStack.init();
  }, []);
  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('document_repo')}
          fileName="Document Repository"
          showmenu={true}
          showdownload={false}
          showIconsForback={false}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <DocumentRepo />,
    },
  ];
 
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};
 
export default DocumentRepoMain;